
import { getNotifications } from "@/service/generatedAlert.service";
import { getImage } from "@/service/image.service";
import { Filter } from "@/types/filter.type";
import { AlertNotification } from "@/types/notificationAlert.type";
import { Pagination } from "@/types/pagination.type";
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "AlertImageComponent",

  props: {
    id: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      alertPagination: undefined as unknown as Pagination<AlertNotification>,
      fileName: "" as string | undefined,
      src: ref<{ [name: string]: string }>({}),
    };
  },

  mounted() {
    this.getAlertNotification();
  },

  methods: {
    async getAlertNotification() {
      try {
        const filter: Filter = {
          fields: {
            "alertNotification.id": {
              operator: "equal",
              value: this.id,
            },
          },
        };

        this.alertPagination = await getNotifications(1, 10, undefined, filter);
        this.fileName = this.alertPagination.data[0].image?.fileName;
        if (this.fileName && !this.src[this.fileName]) {
          getImage(this.fileName, true)
            .then(async (res) => {
              if (this.fileName) {
                this.src[this.fileName] = res;
              }
            })
            .catch(void 0);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error al obtener notificaciones:", error);
      }
    },
  },
});
